// import { isBefore, setHours, setMinutes, addMinutes } from 'date-fns'
// import { useState, useEffect } from 'react'
// import * as React from 'react';
// import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
// import CardContent from '@mui/material/CardContent';
// import Typography from '@mui/material/Typography';
// import { experimentalStyled as styled } from '@mui/material/styles';
// import Box from '@mui/material/Box';
// import Paper from '@mui/material/Paper';
// import Grid from '@mui/material/Grid';
// import { makeStyles } from "@material-ui/styles";
// import axios from 'axios';

// const useStyles = makeStyles((theme) => ({
//   item: {
//     color: '#ccc',
//     justifyContent: "center",
//     textAlign: 'center',
//     marginBottom: 3,
//     display: "flex",
//     '&:hover': {
//       '&>a': {
//         color: 'red',
//       }
//     }
//   }
// }));

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(2),

//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));

// export default function ResponsiveGrid(props) {
//   const setTime = (x, h = 0, m = 0) => setHours(setMinutes(x, m), h)
//   const from = setTime(new Date(), 7)
//   // console.log(from)
//   const to = setTime(new Date(), 21)
//   // console.log(to)
//   const step = (x) => addMinutes(x, 30)
//   const blocks = []
//   let cursor = from
//   while (isBefore(cursor, to)) {
//     // console.log('timings', cursor.toLocaleTimeString())
//     blocks.push(cursor.toLocaleTimeString().slice(-11, -6) + cursor.toLocaleTimeString().slice(-3))
//     cursor = step(cursor)
//   }
//   // console.log(blocks)

//   const classes = useStyles()
//   // console.log('tl props', props)
//   const [reserved, setReserved] = useState([])

//   const getApptTime = (tmslot) => {
//     console.log('tmslot', tmslot);
//     console.log('reserved', reserved);
//     // e.preventDefault()
//     if (reserved.includes(tmslot)) {
//       alert('Already reserved')
//     }
//     else {
//       props.setShowTime(false)
//       props.setApptTime(tmslot);
//     }
//   }

//   useEffect(() => {
//     const jwt = localStorage.getItem('token');
//     const apptUrl = (process.env.REACT_APP_SERVER) ? `https://groomwell-backend.onrender.com/appointments/${props.salonId}/${props.startDate.toUTCString()}`
//       : `http://localhost:3001/appointments/${props.salonId}/${props.startDate.toUTCString()}`

//     const getCurrentAppts = async () => {
//       try {
//         const response = await axios.get(
//           apptUrl, {
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json',
//             'Authorization': ` ${jwt} `,
//           }
//         }
//         )
//           .then(response => {
//             if (response.status === 200) {
//               // console.log('Appointments this day', response.data)
//               const ampm = response.data.map((tm) => {
//                 let H = tm.substr(0, 2)
//                 let h = H % 12 || 12
//                 let ampm = (H < 12 || H === 24) ? " AM" : " PM"
//                 tm = h + tm.substr(2, 3) + ampm
//                 return tm
//               })
//               // console.log('ampm', ampm)
//               setReserved(ampm)
//             }
//           })
//       } catch (err) {
//         // console.log('e', err.message)
//         setReserved(null);
//       }
//     }

//     getCurrentAppts()

//   }, [])
//   var cardStyle = {
//     display: 'block',
//     width: '18vw',
//     transitionDuration: '0.3s',
//     height: '40vw',
//     backgroundColor: 'white',
//     position: 'relative',
//     border: '1',

//   }

//   return (

//     <>

//       <Card style={cardStyle}
//         sx={{ maxHeight: 900, border: 1, marginLeft: 10 }}
//       >
//         <CardContent>
//           <Typography gutterBottom variant="subtitle1" component="div" sx={{ textAlign: 'center' }}>
//             Time Slots
//             <Box sx={{ display: 'flex', justifyContent: 'center' }}>
//               <Box
//                 sx={{

//                   width: 80,
//                   height: 30,
//                   backgroundColor: '#42e3f5',
//                   '&:hover': {
//                     backgroundColor: 'primary.main',
//                     opacity: [0.9, 0.8, 0.7],
//                   },
//                 }}
//               />
//               <Box
//                 sx={{
//                   width: 80,
//                   height: 30,
//                   border: 1,
//                   marginLeft: 2,
//                   backgroundColor: 'white',
//                   '&:hover': {
//                     backgroundColor: 'primary.main',
//                     opacity: [0.9, 0.8, 0.7],
//                   },
//                 }}
//               />
//             </Box>
//           </Typography>
//           <Typography component='div' variant='subtitle1' sx={{ textAlign: 'center' }}>Booked : Free</Typography>
//           <Grid container columns={{ xs: 2, sm: 4, md: 6 }} sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>

//             {blocks.map((tmslot, index) => (
//               <Grid item
//                 className=
//                 {classes.item} key={index} sx={{ width: 100, height: 31, }}
//               >
//                 <Item className=
//                   {classes.item} key={index} sx={{
//                     backgroundColor: (reserved.includes(tmslot) ? '#42e3f5' : 'white'), marginLeft: 0
//                   }}
//                   onClick={() => getApptTime(tmslot)

//                   }>
//                   <a href="#">{tmslot}</a></Item>
//               </Grid>
//             ))}
//           </Grid>

//         </CardContent>

//         <CardActions>


//         </CardActions>

//       </Card>
//     </>
//   );
// }



// mobile friendly code

import { isBefore, setHours, setMinutes, addMinutes } from 'date-fns';
import { useState, useEffect } from 'react';
import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { experimentalStyled as styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';


const useStyles = makeStyles((theme) => ({
  item: {
    color: '#ccc',
    justifyContent: 'center',
    textAlign: 'center',
    marginBottom: 3,
    display: 'flex',
    '&:hover': {
      color: 'red',
      cursor: 'pointer',
    },
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1), // Reduced padding for better fit
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function TimeSlots(props) {

  const { setApptTime, setShowTime, startDate, salonId, salonOpens, salonCloses } = props;

  var date = new Date(salonOpens);
  var hours = date.getHours();
  // console.log('hours', hours);

  const setTime = (x, h = 0, m = 0) => setHours(setMinutes(x, m), h)
  // const from = setTime(new Date(), hours)
  const from = setTime(new Date(startDate), new Date(salonOpens).getHours(), 0);
  const to = setTime(new Date(startDate), new Date(salonCloses).getHours(), 0);
  date = new Date(salonCloses);
  hours = date.getHours();
  // console.log('hours', hours);
  // const to = setTime(new Date(), hours)
  // console.log('startDate', startDate, 'salonOpens', from, 'salonCloses', to);
  const step = (x) => addMinutes(x, 30)
  const blocks = []
  let cursor = from
  while (isBefore(cursor, to)) {
    // blocks.push(
    blocks.push(cursor.toLocaleTimeString().slice(-11, -6) + cursor.toLocaleTimeString().slice(-3))
    // cursor.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    // );
    // blocks.push(cursor.toLocaleTimeString().slice(-11, -6) + cursor.toLocaleTimeString().slice(-3))
    cursor = step(cursor)
  }

  const classes = useStyles();
  const [reserved, setReserved] = useState([]);

  const getApptTime = (tmslot) => {
    // console.log('tmslot', toString(tmslot));
    // console.log('reserved', reserved);
    if (reserved.includes(tmslot)) {
      alert('Already reserved');
    } else {
      setShowTime(false);
      setApptTime(tmslot);
    }
  };

  // const getApptTime = (tmslot) => {
  //   const cleanTmslot = String(tmslot).trim().toLowerCase();
  //   const cleanReserved = reserved.map(r => String(r).trim().toLowerCase());

  //   if (cleanReserved.includes(cleanTmslot)) {
  //     alert("Already reserved");
  //     return;
  //   }

  //   setShowTime(false);
  //   setApptTime(tmslot);
  // };

  useEffect(() => {
    const jwt = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      // No need to set user state since it's not used in the component
      // console.log('ddd', JSON.parse(savedUser));
    }

    const apptUrl = process.env.REACT_APP_SERVER
      ? `https://salonserver-k8m8.onrender.com/appointments/${salonId}/${startDate.toUTCString()}`
      : `http://localhost:3001/appointments/${salonId}/${startDate.toUTCString()}`;

    const getCurrentAppts = async () => {
      try {
        const response = await axios.get(apptUrl, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': ` ${jwt} `,
          },
        });

        if (response.status === 200) {
          // console.log('Appointments this day', response.data);
          const ampm = response.data.map((tm) => {
            let H = tm.substr(0, 2);
            let h = H % 12 || 12;
            let ampm = H < 12 || H === 24 ? ' AM' : ' PM';
            tm = h + tm.substr(2, 3) + ampm;
            return tm;
          });
          // console.log('ampm', ampm);
          setReserved(ampm);
        }
      } catch (err) {
        // console.log('e', err.message);
        setReserved([]);
      }
    };

    getCurrentAppts();
  }, [salonId, startDate]);


  const cardStyle = {
    display: "block",
    width: "100%", // Full width on mobile
    maxWidth: "400px", // Restrict too wide on desktop
    height: "auto",
    maxHeight: "70vh", // Make it proportional to screen
    overflowY: "auto",
    backgroundColor: "white",
    margin: "10px auto", // Center it
    border: "1px solid #ccc",
  };

  return (
    <Card style={cardStyle}>
      <CardContent sx={{ position: 'relative', zIndex: 10 }}>
        <Typography
          gutterBottom
          variant="subtitle1"
          component="div"
          sx={{ textAlign: "center" }}
        >
          Time Slots
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
            <Box
              sx={{
                width: 60,
                height: 25,
                backgroundColor: "#42e3f5",
                mx: 1,
              }}
            />
            <Box
              sx={{
                width: 60,
                height: 25,
                border: 1,
                backgroundColor: "white",
              }}
            />
          </Box>
        </Typography>

        <Typography
          component="div"
          variant="subtitle2"
          sx={{ textAlign: "center", mb: 1 }}
        >
          Booked : Free
        </Typography>

        <Grid
          container
          spacing={1}
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)", // 2 per row on mobile
              sm: "repeat(3, 1fr)", // 3 per row on tablets
              md: "repeat(4, 1fr)", // 4 per row on desktop
            },
            gap: 1,
          }}
        >
          {blocks.map((tmslot, index) => (



            <Grid item key={index}
            // className=
            // {classes.item} key={index} sx={{ width: 100, height: 31, }}
            >
              <Item
                sx={{
                  // backgroundColor: (reserved.includes(tmslot) ? '#42e3f5' : 'white'),
                  backgroundColor:
                    reserved
                      .map(t => t.trim().toUpperCase())
                      .includes(String(tmslot).trim().toUpperCase())
                      ? "#42e3f5"
                      : "white",
                  fontSize: { xs: "0.75rem", sm: "0.85rem" },
                  py: 0.5,
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#eee" },
                }}
                onClick={() => getApptTime(tmslot)}
              >
                {tmslot}
                {/* {console.log('tmslot', tmslot)} */}
                {/* {console.log('reserved', reserved)} */}
              </Item>
              {/* <Item
                className=
                {classes.item} key={index} sx={{
                  backgroundColor: (reserved.includes(tmslot) ? '#42e3f5' : 'white'), 
                  marginLeft: 0
                }}
                onClick={() => getApptTime(tmslot)

                }>
                <a href="#">{tmslot}</a>
              </Item> */}
            </Grid>
            // <Grid item key={index}>
            //   <Item
            //     sx={{
            //       backgroundColor:
            //         reserved
            //           .map(t => t.trim().toUpperCase())
            //           .includes(String(tmslot).trim().toUpperCase())
            //           ? "#42e3f5"
            //           : "white",
            //       fontSize: { xs: "0.75rem", sm: "0.85rem" },
            //       py: 0.5,
            //       cursor: "pointer",
            //       "&:hover": { backgroundColor: "#eee" },
            //     }}
            //     onClick={() => getApptTime(tmslot)}
            //   >
            //     {tmslot}
            //   </Item>

            // </Grid>

          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}
